export enum BundleStatusEnum {
  Published = 'published',
  Unpublished = 'unpublished'
  // v1 code uncomment for now
  // Purchased = 'purchased'
}
